const DEFAULT_HOME_FEED_COUNT = 10;
export const HOME_FEED_INCREMENT = 10;
export const MAX_HOME_FEED_COUNT = 100;

function cloneSearchParams(rawSearch: string): URLSearchParams {
  return new URLSearchParams(rawSearch);
}

export function normalizeHomeFeedCount(rawCount: string | null): number {
  if (!rawCount) {
    return DEFAULT_HOME_FEED_COUNT;
  }

  const parsed = Number(rawCount);

  if (!Number.isInteger(parsed) || parsed <= DEFAULT_HOME_FEED_COUNT) {
    return DEFAULT_HOME_FEED_COUNT;
  }

  return Math.min(parsed, MAX_HOME_FEED_COUNT);
}

export function buildCanonicalHomeFeedUrl(pathname: string, rawSearch: string): string {
  const params = cloneSearchParams(rawSearch);
  const normalizedCount = normalizeHomeFeedCount(params.get('count'));

  if (normalizedCount === DEFAULT_HOME_FEED_COUNT) {
    params.delete('count');
  } else {
    params.set('count', String(normalizedCount));
  }

  const query = params.toString();
  return query ? `${pathname}?${query}` : pathname;
}

export function buildHomeFeedUrl(pathname: string, rawSearch: string, nextCount: number): string {
  const params = cloneSearchParams(rawSearch);
  const normalizedNext = Math.min(
    Math.max(nextCount, DEFAULT_HOME_FEED_COUNT),
    MAX_HOME_FEED_COUNT
  );

  if (normalizedNext === DEFAULT_HOME_FEED_COUNT) {
    params.delete('count');
  } else {
    params.set('count', String(normalizedNext));
  }

  const query = params.toString();
  return query ? `${pathname}?${query}` : pathname;
}
